import { render, staticRenderFns } from "./TestThree.vue?vue&type=template&id=c8c34216&scoped=true"
import script from "./TestThree.vue?vue&type=script&lang=js"
export * from "./TestThree.vue?vue&type=script&lang=js"
import style0 from "./TestThree.vue?vue&type=style&index=0&id=c8c34216&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c34216",
  null
  
)

export default component.exports